import SEOxProjectList from './SEOxProjectList.container';

export default SEOxProjectList;
